__turbopack_context__.v({
  "mochi-radio": "mochi-radio-module-scss-module__nt3FqG__mochi-radio",
  "mochi-radio-label": "mochi-radio-module-scss-module__nt3FqG__mochi-radio-label",
  "mochi-radio__checked": "mochi-radio-module-scss-module__nt3FqG__mochi-radio__checked",
  "mochi-radio__empty-state": "mochi-radio-module-scss-module__nt3FqG__mochi-radio__empty-state",
});
